















































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppSimpleSelector extends Vue {
  @Prop(Number) readonly value!: number;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: [Number, String], default: 289 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: Array }) readonly items!: string[];
  @Prop({ type: Boolean, default: true }) readonly isShowAll!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  model = '';

  mounted () {
    this.model = this.value === -1 ? '' : this.items[this.value]
  }

  @Watch('value')
  onValueChanged (val: number) {
    this.model = val === -1 ? '' : this.items[val]
  }

  @Emit('input')
  valueChangedHandler (val: string, index: number) {
    this.model = val
    return index
  }

  @Watch('items')
  onItemsChanged (val: string[]) {
    this.model = this.value === -1 ? '' : val[this.value]
  }

  @Emit()
  submit () {
    // do nothing
  }
}
